export default __webpack_public_path__ + "static/media/info.4cc9ce9b.svg";